import { render, staticRenderFns } from "./orderSection.vue?vue&type=template&id=130973c3&scoped=true&"
import script from "./orderSection.vue?vue&type=script&lang=js&"
export * from "./orderSection.vue?vue&type=script&lang=js&"
import style0 from "./orderSection.vue?vue&type=style&index=0&id=130973c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130973c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130973c3')) {
      api.createRecord('130973c3', component.options)
    } else {
      api.reload('130973c3', component.options)
    }
    module.hot.accept("./orderSection.vue?vue&type=template&id=130973c3&scoped=true&", function () {
      api.rerender('130973c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/modifySupplement/orderSection.vue"
export default component.exports